module.exports = __webpack_public_path__ + "static/media/historian.fd22a72f.jpg";